<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 960px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -480px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}

.title-close div {
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  margin-top: 10px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
  font-size: 12px;
  padding: 0 6px
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
  word-break: keep-all;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 8px 0;
  color: #323233;
}

/deep/ .el-table td {
  padding: 8px 0px;
}

/deep/.el-input-number__decrease {
  height: 33px;
  top: 3px
}

/deep/ .el-input-number__increase {
  height: 33px;
  top: 3px
}

.table-wrap {
  margin: 20px;
  margin-top: 0;
}

.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color: #666;
}


.search {
  display: flex;
  align-items: center;
  padding-left: 20px;

}

.input {
  background: none;
  outline: none;
  border: none;
  width: 200px;
  height: 32px;
  margin: 10px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  padding-left: 10px;
}

.search .btn {
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  width: 60px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  margin-left: 10px;

  border: 1px solid transparent;
  cursor: pointer;
}

.search .btn.gray {
  border: 1px solid #D9D9D9;
  color: #212121;
  background: #fff;
}

.search-sum {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
}
</style>
<style>
.myTooltips {
  max-width: 70% !important;


}
</style>
<template>
  <div class="main">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title" style="margin-bottom:0">特别提醒</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="tips">
        以下人员在<span style="font-weight:bold;">[{{ taskDetail.month ?$moment(taskDetail.month).format('YYYY年MM月') : ($moment(taskDetail.startTime).format('YYYY-MM-DD') + '至' +
          $moment(taskDetail.endTime).format('YYYY-MM-DD')) }}]</span> 存在多地派发任务的情况，请慎重检查后再派发!
      </div>
      <div class="table-wrap">
        <el-table tooltip-effect="dark myTooltips" :data="detail" max-height="500" stripe border
          header-cell-class-name="table_header">

          <el-table-column show-overflow-tooltip label="服务人员" width="196" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffName }}{{ scope.row.idCode?'-'+scope.row.idCode.replace(/^(.{6})(?:\d+)(.{4})$/,
              '\$1******\$2'):'' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="平台账号" width="120" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :renderHeader="renderHeader" label="任务包名称" width="460" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskTitleList.join('，') }}</template>
          </el-table-column>
  
          <el-table-column show-overflow-tooltip label="费用总额(元)" width="110" header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.taskSumAmount | numFmt | numDigit}}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="服务商" width="240" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template>
          </el-table-column>


        </el-table>
      </div>
      <div class="btns " @click="surePost">
        确认
      </div>
      <div class="btns cancel" @click="close">
        取消
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Array,
      default: [],
    },
    taskDetail: {
      type: Object,
      default: {},
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    close() {
      this.$emit('close')
    },
    surePost() {
      this.$emit('close');
      this.$emit('surePost');
    },
    renderHeader: function (h, { column, $index }) {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'top',
                effect: 'dark',
                //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  //当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                
                ['1、某个任务包费用总额 = 名任务单价 * 各个任务的计划量之和；',
                h('br'),
                '2、费用金额中排除不限量的任务费用，因为不限量任务没有目标量，无法计算出费用。']
              ),
              h('span', {
                //问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },
  },
};
</script>